export default __webpack_public_path__ + "static/media/build-together.78627585.png";